export enum AuctionOfferStatus {
	AWARDED = 'awarded',
	PENDING = 'pending',
	REJECTED = 'rejected'
}
